import { render, staticRenderFns } from "./AnimationCheck.vue?vue&type=template&id=28681e5f&scoped=true"
import script from "./AnimationCheck.vue?vue&type=script&lang=js"
export * from "./AnimationCheck.vue?vue&type=script&lang=js"
import style0 from "./AnimationCheck.vue?vue&type=style&index=0&id=28681e5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28681e5f",
  null
  
)

export default component.exports